export const messages = {
  en: {
    userDetailRefundGroupOrders: {
      refundId: 'Refund ID',
      order: 'Order',
      product: 'Product',
      buyer: 'Buyer',
      buyQuantity: 'Purchase Quantity',
      groupPrice: 'Group Price',
      refundAmount: 'Refund Amount',
      refundType: 'Refund Type',
      selfRefund: 'Self Refund',
      groupFailedRefund: 'Group Failed Refund',
      refundReason: 'Refund Reason',
      status: 'Status',
      reviewNote: 'Review Note'
    }
  },
  zh: {
    userDetailRefundGroupOrders: {
      refundId: '退单编号',
      order: '订单',
      product: '商品',
      buyer: '购买人',
      buyQuantity: '购买数量',
      groupPrice: '拼团价格',
      refundAmount: '退款金额',
      refundType: '退款类型',
      selfRefund: '自主退款',
      groupFailedRefund: '拼团失败退款',
      refundReason: '退款原因',
      status: '状态',
      reviewNote: '审核说明'
    }
  }
}